import React from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import { statusAlumni } from './redux/reduxApi';

const actions = {
  closeModal,
  statusAlumni,
};

function ModalStatus({ data, closeModal, statusAlumni }) {
  const { auth, history, item, onClose } = data || {};
  const studentUserId = item?.studentUserId;
  let status = item?.status; //status false

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
    closeModal();
  };

  async function setStatus() {
    if (!item) {
      handleClose();
      return;
    }

    if (!auth || !history) {
      handleClose();
      return;
    }

    await statusAlumni({ auth, history, studentUserId, status });
    if (typeof onClose === 'function') {
      onClose();
    }
    closeModal();
  }

  return (
    <Modal variant='info' closeModal={handleClose}>
      <p className='my-3 mx-1'>
        Apakah Anda ingin set Siswa{' '}
        <span className='has-text-danger has-text-weight-semibold is-capitalized'>
          {item.name}
        </span>{' '}
        menjadi {item.status ? 'Alumni' : 'siswa'} ?
      </p>
      <div className='flex justify-end align-center pt-2'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={setStatus} />
          <Button cvariant='cback' onClick={handleClose} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalStatus);
